module.exports = __webpack_public_path__ + "img/orderAnalyModel2.d5e03cc5.png";